import { useStaticQuery, graphql } from 'gatsby';
import { withCompetitor } from '@lucid/utils';

import type { Lucid } from '../types/types';
import { type Product } from '../../../../lucid-types/src/product';

const useCompetitor = (languageKey: Lucid.I18n.LanguagesShortCode, templateProduct: Product.Sites) => {
  const { directus, i18nData } = useStaticQuery<Lucid.Query.Hooks.UseCompetitor>(graphql`
    query UseCompetitorQuery {
      directus {
        competitor2Pages: competitor_2(limit: 1000, filter: { status: { _eq: "published" } }, sort: "competitor") {
          competitor
          translations(filter: { is_published: { _eq: true } }) {
            languages_code {
              short_code
            }
            path {
              url
            }
          }
        }
        competitorPages: competitor(limit: 1000, filter: { status: { _eq: "published" } }, sort: "competitor") {
          competitor
          translations(filter: { is_published: { _eq: true } }) {
            languages_code {
              short_code
            }
            path {
              url
            }
          }
        }
      }
      i18nData: allFile(filter: { sourceInstanceName: { eq: "i18n" } }) {
        edges {
          node {
            name
            childSrcJson {
              mktg_competitor_compare
            }
          }
        }
      }
    }
  `);

  return withCompetitor(directus, i18nData, templateProduct, languageKey);
};

export default useCompetitor;
